import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var log = typeof debug !== "undefined";
        if (log) console.log("%cevent_esc-key.js initialized", "color: green;");

        $(window).on("keyup", function (_e) {
            if (_e.key == "Escape") {
                $(window).trigger("escKey");
            }
        });
    });
})();
